import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { splitChatTokens } from '@long-game/common';
import { GameTitleChatToken } from './tokens/GameTitleChatToken';
import { PlayerHandleChatToken } from './tokens/PlayerHandleChatToken';
export function ChatTextWithTokens({ children }) {
    const parts = splitChatTokens(children);
    return (_jsx(_Fragment, { children: parts.map((part, index) => {
            if (typeof part === 'string') {
                return part;
            }
            if (part.type === 'game' && part.role === 'title') {
                return _jsx(GameTitleChatToken, { token: part }, index);
            }
            if (part.type === 'player' && part.role === 'handle') {
                return _jsx(PlayerHandleChatToken, { token: part }, index);
            }
            return (_jsx("span", { "data-unknown-token": true, "data-debug": JSON.stringify(part), children: "???" }, index));
        }) }));
}
//# sourceMappingURL=ChatTextWithTokens.js.map